import cn from 'classnames';
import { forwardRef } from 'react';

import Slot from '../../../utils/slot';

import type { ForwardedRef, ReactElement } from 'react';

import type { DescriptionProps } from './description.types';

import './description.scss';

/**
 * Description component which also supports as being used as a slot for different components.
 *
 * ### Usage
 *
 * ```tsx
 * import { Description } from '@bloomreach/react-banana-ui';
 *
 * export default function MyCustomComponent() {
 *   return <Description>This is a description component</Description>;
 * }
 * ```
 */
const Description = forwardRef(
  (props: DescriptionProps, forwardedRef: ForwardedRef<HTMLDivElement> | null): ReactElement => {
    const {
      children,
      className,
      ...rest // Capture any other properties to pass them to the root element, like `aria-*`, `data-*`, etc.
    } = props;

    return (
      <Slot name="Description">
        <div {...rest} className={cn('rbui-description', className)} ref={forwardedRef}>
          {children}
        </div>
      </Slot>
    );
  },
);

Description.displayName = 'Description';

export default Description;
